import {
  getFontCss,
  styleConstants,
  themeConstants,
} from '@paywithextend/components'
import React from 'react'
import { css } from 'styled-components'

export enum HoverTooltipChevronPosition {
  Center,
  Left,
  Right,
}
interface HoverTooltipProps {
  className?: string
  show: boolean
  tooltipText: React.ReactNode
  wrapText?: boolean
  maxWidth?: number
  chevronPosition?: HoverTooltipChevronPosition
}

// Parent element should have a position of relative
const HoverTooltip: React.FC<HoverTooltipProps> = (
  props,
): React.ReactElement => {
  const chevronPosition =
    props.chevronPosition ?? HoverTooltipChevronPosition.Center
  return (
    <span
      className={props.className}
      css={css`
        display: ${props.show ? 'inherit' : 'none'};
        width: max-content;
        max-width: ${props.maxWidth || 240}px;
        position: absolute;
        background-color: ${themeConstants.colors.font_primary};
        ${getFontCss(
          12,
          styleConstants.colors.white,
          styleConstants.fontFamilies.regular,
        )};
        text-align: center;
        padding: 8px;
        border-radius: 8px;
        // TODO: we should use design system constants for this
        z-index: 1001;
        opacity: ${props.show ? '1' : '0'};
        transition: opacity 0.6s;
        white-space: ${(props.wrapText ?? true) ? 'normal' : 'nowrap'};

        top: 150%;

        ${chevronPosition === HoverTooltipChevronPosition.Center &&
        css`
          transform: translate(-50%);
          left: 50%;
        `}

        ${chevronPosition === HoverTooltipChevronPosition.Left &&
        css`
          transform: translate(-25%);
          left: 150%;
        `}
        
        ${chevronPosition === HoverTooltipChevronPosition.Right &&
        css`
          transform: translate(-75%);
          left: -50%;
        `}
          

        &::after {
          content: '';
          position: absolute;
          bottom: 100%;
          margin-left: -8px;
          border-width: 8px;
          border-style: solid;
          border-color: transparent transparent
            ${themeConstants.colors.font_primary} transparent;

          ${chevronPosition === HoverTooltipChevronPosition.Center &&
          css`
            left: 50%;
          `}
          ${chevronPosition === HoverTooltipChevronPosition.Left &&
          css`
            left: 10%;
          `}
          ${chevronPosition === HoverTooltipChevronPosition.Right &&
          css`
            left: 90%;
          `}
        }
      `}
    >
      {props.tooltipText}
    </span>
  )
}

export default HoverTooltip
